export const SHOW_RECIPIENT_FIELD = 'SHOW_RECIPIENT_FIELD'
export const SHOW_ANNOUNCEMENT_FIELD = 'SHOW_ANNOUNCEMENT_FIELD'
export const SHOW_NEW_MESSAGE = 'SHOW_NEW_MESSAGE'

export const CREATE_CHAT_BEGIN = 'CREATE_CHAT_BEGIN'
export const CREATE_CHAT_SUCCESS = 'CREATE_CHAT_SUCCESS'
export const CREATE_CHAT_ERROR = 'CREATE_CHAT_ERROR'

export const GET_STORE_EMPLOYEES_BEGIN = 'GET_STORE_EMPLOYEES_BEGIN'
export const GET_STORE_EMPLOYEES_SUCCESS = 'GET_STORE_EMPLOYEES_SUCCESS'
export const GET_STORE_EMPLOYEES_ERROR = 'GET_STORE_EMPLOYEES_ERROR'

export const GET_CONVERSATIONS_BEGIN = 'GET_CONVERSATIONS_BEGIN'
export const GET_CONVERSATIONS_SUCCESS = 'GET_CONVERSATIONS_SUCCESS'
export const GET_CONVERSATIONS_ERROR = 'GET_CONVERSATIONS_ERROR'

export const SET_CHAT_ROOM_ID = 'SET_CHAT_ROOM_ID'

export const SOCKET_MESSAGE_RECEIVED = 'SOCKET_MESSAGERECEIVED'
export const SOCKET_ADD_NEW_CHAT_ROOM = 'SOCKET_ADDNEWCHATROOM'

export const NEW_MESSAGE_TOGGLE = 'NEW_MESSAGE_TOGGLE'

export const JOIN_CHAT_ROOM_BEGIN = 'JOIN_CHAT_ROOM_BEGIN'
export const JOIN_CHAT_ROOM_SUCCESS = 'JOIN_CHAT_ROOM_SUCCESS'
export const JOIN_CHAT_ROOM_ERROR = 'JOIN_CHAT_ROOM_ERROR'

export const LOAD_MORE_MESSAGES_BEGIN = 'LOAD_MORE_MESSAGES_BEGIN'
export const LOAD_MORE_MESSAGES_SUCCESS = 'LOAD_MORE_MESSAGES_SUCCESS'
export const LOAD_MORE_MESSAGES_ERROR = 'LOAD_MORE_MESSAGES_ERROR'

export const RETRY_FAILED_MESSAGES_BEGIN = 'RETRY_FAILED_MESSAGES_BEGIN'
export const RETRY_FAILED_MESSAGES_SUCCESS = 'RETRY_FAILED_MESSAGES_SUCCESS'
export const RETRY_FAILED_MESSAGES_ERROR = 'RETRY_FAILED_MESSAGES_ERROR'

export const UPDATE_MESSAGE_STATUS_READ_SUCCESS = 'UPDATE_MESSAGE_STATUS_READ_SUCCESS'

export const SET_LAST_MESSAGE_RECEIVED_ID = "SET_LAST_MESSAGE_RECEIVED_ID"

export const UPDATE_NOTIFICATION_OPTIONS = 'UPDATE_NOTIFICATION_OPTIONS'

export const GET_UNREAD_MESSAGE_LENGTH_SUCCESS = "GET_UNREAD_MESSAGE_LENGTH_SUCCESS"

export const DELETE_CHAT_HISTORY_BEGIN = 'DELETE_CHAT_HISTORY_BEGIN'
export const DELETE_CHAT_HISTORY_SUCCESS = 'DELETE_CHAT_HISTORY_SUCCESS'
export const DELETE_CHAT_HISTORY_ERROR = 'DELETE_CHAT_HISTORY_ERROR'

export const GET_CHATROOM_MESSAGES_BEGIN = "GET_CHATROOM_MESSAGES_BEGIN"
export const GET_CHATROOM_MESSAGES_SUCCESS = "GET_CHATROOM_MESSAGES_SUCCESS"
export const GET_CHATROOM_MESSAGES_ERROR = "GET_CHATROOM_MESSAGES_ERROR"

export const INTERNET_CONNECTED = "INTERNET_CONNECTED"